import { useMemo } from 'react';

// components
import { CompactTabItem } from '../../components/nav/CompactTabMenu/CompactTab';

import { FormulaType } from '../../constants/formulaType';

// helpers
import { renderFormulaChannelTabs } from '../../helpers/formulaHelpers';

// models
import { FormulaCategory } from '../../models/formula.model';

// hooks
import useFormulasCategoryCountQuery from './useFormulasCategoryCount';

export const useGetFormulaChannelTabsData = (status: FormulaCategory) => {
    const { data: counts, isPending: isLoading } =
        useFormulasCategoryCountQuery();

    const formulaTypeTabs = useMemo<CompactTabItem[]>(
        () => renderFormulaChannelTabs(status, counts),
        [counts, status],
    );

    return {
        isLoading,
        tabs: formulaTypeTabs,
        formulaTypeInitialValue:
            formulaTypeTabs[0]?.key || FormulaType.mobilePush,
    };
};
